import script from "./RatingSkillsTableMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingSkillsTableMobile.vue?vue&type=script&setup=true&lang=js"

import "./RatingSkillsTableMobile.vue?vue&type=style&index=0&id=7cc4604c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cc4604c"]])

export default __exports__